var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.app)?_c('div',{staticClass:"view--settings"},[_c('app-settings-header',{attrs:{"app":_vm.app}}),_c('app-settings-content',{attrs:{"app":_vm.app,"subscription":_vm.activeSub}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }